import React, {Fragment} from 'react';
import { Wide, WideToolbar, WideRow, Compact, CompactToolbar, CompactRow, Label } from '@newageerp/ui.form.base.form-pack';
import { useTranslation } from 'react-i18next'
import { Datepicker } from "@newageerp/ui.form.base.form-pack";
import { Input } from "@newageerp/ui.form.base.form-pack";
import { InputFloat } from "@newageerp/ui.form.base.form-pack";

interface Props {
    element: any;
    onChange: (key: string, value: any) => void,
    compact?: boolean,

    onSave: () => void,
    onCancel: () => void,
}

export default function InvoiceMainForm(props: Props) {
    const { element, onChange } = props;
    const { t } = useTranslation();

    if (props.compact) {
        return (
            <Compact>
                <CompactRow label={<Label>{t('Data')}</Label>} control={<Datepicker value={element.date} onChange={(e: any) => onChange('date', e)}  className={"field-date"}/>}/>
<CompactRow label={<Label>{t('Numeris')}</Label>} control={<Input onChange={(e: any) => onChange('serialNoFormatted', e.target.value)} value={element.serialNoFormatted}/>}/>
<CompactRow label={<Label>{t('Kursas')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('currencyRate', e)} value={element.currencyRate} className={"field-float"}/>}/>
                <CompactToolbar onSave={props.onSave} onCancel={props.onCancel} />
            </Compact>
        )
    }

    return (
        <Wide>
            <WideRow label={<Label>{t('Data')}</Label>} control={<Datepicker value={element.date} onChange={(e: any) => onChange('date', e)}  className={"field-date"}/>}/>
<WideRow label={<Label>{t('Numeris')}</Label>} control={<Input onChange={(e: any) => onChange('serialNoFormatted', e.target.value)} value={element.serialNoFormatted}/>}/>
<WideRow label={<Label>{t('Kursas')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('currencyRate', e)} value={element.currencyRate} className={"field-float"}/>}/>
            <WideToolbar onSave={props.onSave} onCancel={props.onCancel} />
        </Wide>
    )
}